import { Link, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";

export default function Sidebar() {
  const location = useLocation();

  return (
    <div className="sidebar">
      <nav className="sidebar-nav">

        <Link
          to="/dashboard"
          className={`sidebar-link ${
            location.pathname === "/dashboard" ? "active" : ""
          }`}
        >
          Dashboard
        </Link>

        <Link
          to="/leads"
          className={`sidebar-link ${
            location.pathname === "/leads" ? "active" : ""
          }`}
        >
          Leads
        </Link>

      </nav>
    </div>
  );
}
